import Section from "@/components/ui/section";
import Seo from "@/utils/seo";
import React from "react";

export default function TermsAndConditions() {
  return (
    <>
      <Seo
        metaTitle="Terms and Conditions | Rose Bowl"
        slug="/terms-and-conditions"
      />

      <Section className="lg:mt-[120px] mt-[90px] postContent bg-beige">
        <h4 id="returns" className="lg:scroll-mt-[140px] scroll-mt-[100px]">
          Return Policy
        </h4>
        <ul>
          <li>
            We offer a simple and easy 7 days return policy to our customers
            from the date of delivery.
          </li>
          <li>
            Please do not accept any order if seal is tampered at the time of
            delivery.{" "}
          </li>
          <li>We do not have COD facility</li>
          <li>
            All returned items must be unused and unwashed for hygiene reasons;
            and returned with original packaging and tags in place.{" "}
          </li>
          <li>
            Subsequent to us approving the return pick up based on the images
            you have shared, your package will be picked up by our courier
            partner at no extra cost to you, within 2-3 business days (excluding
            Sunday).
          </li>
          <li>
            The amount will be refunded to the original source of payment in
            case of prepaid.
          </li>
          <li>
            Please note that it can take upto 5-7 working days to complete the
            refunds. Refunds are initiated once the returned item is received by
            our team and passes quality checks. (Rose Bowl will not be
            responsible for delays in refund processing because of delays caused
            by banks, calamities or national holidays).
          </li>
        </ul>
        <p>
          <strong>NOTE:</strong> Shipping charges are non-refundable.
        </p>
        <h4>Standard Quality Check procedure:-</h4>
        <ul>
          <li>The items should be unused and unwashed for hygiene reasons.</li>
          <li>
            The product should have the original packaging and tags in place.
            Items without the original tags will not be accepted.
          </li>
          <li>
            They return should be initiated within 7 calendar days from the
            delivery date.
          </li>
          <li>
            In case of a damaged/defective product received, rosebowl.in should
            be notified within 24 hours of receipt. We may request you to share
            unboxing video/snap shot at rajeev@rosebowl.in
          </li>
          <li>
            If you choose to self-ship the products, they should be dispatched
            within 48 hours after the return request is raised.
          </li>
        </ul>
        <p>
          Please note that in case the returned product fails to meet any of the
          above mentioned criteria will be deemed as quality fail. No refunds
          shall be issued in such cases.
        </p>
        <p>
          A notification with the status of the return will be sent to the
          customer within 24-48 working hours from the date of receiving the
          items.
        </p>
        <p>
          In case of orders where reverse pick-up may not apply, customers can
          self-ship the items to rosebowl.in. An amount of Rs. 100 will be
          reimbursed in the customer&apos;s account towards shipping costs in
          the form of a Paytm wallet credit/Bank transfer, in such cases.
        </p>
        <h4 id="shipping" className="lg:scroll-mt-[140px] scroll-mt-[100px]">
          Shipping Address for self-shipment of products:
        </h4>
        <p>
          Rose Bowl
          <br />
          86 Vindhachal Apartments
          <br />
          Paschim Vihar <br />
          New Delhi -110087
          <br />
          Contact number: 9818314184
          <br />
        </p>
        <p>
          Please make sure that the returned items are packed securely to
          prevent any loss or damage during transit. For all self-shipped
          returns, please use a reliable courier service.
        </p>
        <h4>The Return / Exchange Process</h4>
        <p>
          You can raise a return or exchange of an item online at rosebowl.in by
          contacting customer support at rajeev@rosebowl.in
        </p>
        <h4>Customer Support</h4>
        <p>
          For any other queries, you can connect with our customer care team by
          e-mailing at rajeev@rosebowl.in
        </p>
        <p>
          Please have the below information ready before you reach out to our
          customer care or mention the same in the email:
        </p>
        <ul>
          <li>Order Number</li>
          <li>Registered E-Mail Id</li>
          <li>Product Name</li>
          <li>Pick-Up Address </li>
        </ul>
        <p>
          To process a return or exchange successfully, please re-pack the items
          to be returned with all the original packaging & tags that they were
          shipped with.
        </p>
        <p>
          Mention the order details & complete shipping address on the packet as
          stated below –
        </p>
        <ul>
          <li>Order Number, Product Name & Return Reference Number</li>
          <li>Shipping Address:</li>
          <li>Rose Bowl</li>
          <li>Paschim Vihar </li>
          <li>New Delhi -110087</li>
          <li>Contact number 9818314184</li>
          <li>
            *Please read the return policy carefully before returning an item.
          </li>
        </ul>
        <p>
          This Return Policy applies to all items purchased directly from
          rosebowl.in (with the exception of Personalized items, discounted and
          free gifts, unless there is a product defect). The policy is subject
          to change. Hence, please visit our website rosebowl.in for the latest
          policy.
        </p>
        <h4>Exchange</h4>
        <p>
          You can exchange an item purchased on www.rosebowl.in with the same
          item or another item, however, all exchanges are subject to stock
          availability
        </p>
      </Section>
    </>
  );
}
